import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useStyles from './styles';
import { AddNewForm } from './form';
import { useStore } from 'src/stores';
import { UsersModal } from './UsersModal';
import { observer } from 'mobx-react-lite';
import { EditModalModal } from './EditModal';
import { Checkbox, IconButton, Menu, MenuItem, TextField, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useVirtualizer } from '@tanstack/react-virtual';
import { SimpleModal, BackdropLoader, toast, Icon, InputWithIcon, ExpandedTooltip } from '@livable/saas-react-components';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { DeleteModal } from './DeleteModal';
// import { GlModal } from './GlModal';
// import { useTranslation } from 'react-i18next';

export const AppfolioPage = observer(() => {
  var _data$find, _data$find2, _data$find3, _data$find4, _data$find5, _data$find6, _data$find7;
  const classes = useStyles();
  const store = useStore();
  // const { t } = useTranslation();

  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    sortType = _useState4[0],
    setSortType = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    data = _useState6[0],
    setData = _useState6[1];
  const _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    dataConst = _useState8[0],
    setDataConst = _useState8[1];
  // const [glData, setGlData] = useState([]);
  const _useState9 = useState(''),
    _useState0 = _slicedToArray(_useState9, 2),
    activeId = _useState0[0],
    setActiveId = _useState0[1];
  const _useState1 = useState(''),
    _useState10 = _slicedToArray(_useState1, 2),
    searchPropertyKey = _useState10[0],
    setSearchPropertyKey = _useState10[1];
  const _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    searchCredentialKey = _useState12[0],
    setSearchCredentialKey = _useState12[1];
  const _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isAddNewOpen = _useState14[0],
    setIsAddNewOpen = _useState14[1];
  const _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    dataProperties = _useState16[0],
    setDataProperties = _useState16[1];
  // const [singleGLAccount, setSingleGLAccount] = useState(null);
  // const [glModalIsOpen, setGlModalIsOpen] = useState(false);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = function () {
    let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    setAnchorEl(null);
    if (type === 'asc') {
      setSortType(type);
      setData(data.sort((a, b) => {
        const nameA = a.name.toLowerCase(),
          nameB = b.name.toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      }));
    } else if (type === 'desc') {
      setSortType(type);
      setData(data.sort((a, b) => {
        const nameA = a.name.toLowerCase(),
          nameB = b.name.toLowerCase();
        if (nameA < nameB) return 1;
        if (nameA > nameB) return -1;
        return 0;
      }));
    } else if (type === 'unsort') {
      setSortType(null);
      setData(dataConst);
    }
  };
  const fetchAppfolioDate = async () => {
    const resp = await store.credentials.getCredentialsAsync.run();
    if (resp && resp.response && resp.response.length) {
      setActiveId(resp.response[0].id);
      setData(resp.response);
      setDataConst(resp.response);
      const propertiesResp = await store.credentials.getCredentialsPropertiesAsync.run({
        credentialsId: resp.response[0].id
      });
      setDataProperties(propertiesResp.response);

      // const glAccountsResp = await store.credentials.getGlAccountsAsync.run({ credentialsId: resp.response[0].id });

      // setGlData(glAccountsResp.response);
    } else {
      setData([]);
      setDataConst([]);
      // setGlData([]);
      setActiveId('');
      setDataProperties([]);
    }
  };
  const fetchAppfolioBatchQueueDate = async () => {
    if (!activeId) return;
    const propertiesResp = await store.credentials.getCredentialsPropertiesAsync.run({
      credentialsId: activeId
    });
    setDataProperties(propertiesResp.response);
  };
  const fetchAppfolioDateAfterAddNew = async () => {
    const resp = await store.credentials.getCredentialsAsync.run();
    if (resp && resp.response && resp.response.length) {
      if (!data.length) {
        setActiveId(resp.response[0].id);
        const propertiesResp = await store.credentials.getCredentialsPropertiesAsync.run({
          credentialsId: resp.response[0].id
        });
        setDataProperties(propertiesResp.response);

        // const glAccountsResp = await store.credentials.getGlAccountsAsync.run({ credentialsId: resp.response[0].id });

        // setGlData(glAccountsResp.response);
      }
      setData(resp.response);
      setDataConst(resp.response);
    }
  };
  const handleChangeActiveId = async id => {
    setActiveId(id);
    const propertiesResp = await store.credentials.getCredentialsPropertiesAsync.run({
      credentialsId: id
    });
    setDataProperties(propertiesResp.response);

    // const glAccountsResp = await store.credentials.getGlAccountsAsync.run({ credentialsId: id });

    // setGlData(glAccountsResp.response);
  };
  const handleMakeApproved = async () => {
    const cData = {
      credentialsId: activeId,
      requestData: []
    };
    store.credentials.selectedItems.map(i => {
      cData.requestData.push({
        appfolioPropertyId: i,
        isApproved: {
          value: true
        }
      });
    });
    const resp = await store.credentials.patchCredentialsPropertiesAsync.run(cData);
    if (resp && resp.isSuccessful) {
      toast('success', {
        body: ['Successfully saved']
      });
      store.credentials.resetSelectedItems();
      const propertiesResp = await store.credentials.getCredentialsPropertiesAsync.run({
        credentialsId: activeId
      });
      setDataProperties(propertiesResp.response);
    }
  };

  // const handleGLAccount = async glId => {
  //   const cData = {
  //     credentialsId: activeId,
  //     requestData: [],
  //   };

  //   if (singleGLAccount) {
  //     cData.requestData.push({
  //       appfolioPropertyId: singleGLAccount,
  //       glAccountExternalId: {
  //         value: glId,
  //       },
  //     });
  //   } else {
  //     store.credentials.selectedItems.map(i => {
  //       cData.requestData.push({
  //         appfolioPropertyId: i,
  //         glAccountExternalId: {
  //           value: glId,
  //         },
  //       });
  //     });
  //   }

  //   const resp = await store.credentials.patchCredentialsPropertiesAsync.run(cData);

  //   if (resp && resp.isSuccessful) {
  //     toast('success', { body: ['Successfully saved'] });
  //     store.credentials.resetSelectedItems();

  //     const propertiesResp = await store.credentials.getCredentialsPropertiesAsync.run({
  //       credentialsId: activeId,
  //     });

  //     setDataProperties(propertiesResp.response);

  //     setGlModalIsOpen(false);
  //     setSingleGLAccount(null);
  //   }
  // };

  useEffect(() => {
    fetchAppfolioDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const propertySearchQ = searchPropertyKey.trim().toLocaleLowerCase();
  const filteredProperties = !dataProperties.length ? [] : propertySearchQ === '' ? dataProperties : dataProperties.filter(row => (row === null || row === void 0 ? void 0 : row.name) && row.name.toLocaleLowerCase().includes(propertySearchQ) || (row === null || row === void 0 ? void 0 : row.address) && row.address.toLocaleLowerCase().includes(propertySearchQ));
  const propertiesScrollRef = useRef(null);
  const propertyRowVirtualizer = useVirtualizer({
    count: filteredProperties.length,
    getScrollElement: () => propertiesScrollRef.current,
    estimateSize: () => 73,
    overscan: 10
  });
  const isPropertyTableAdmin = store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin;
  const propertyTableColCount = isPropertyTableAdmin ? 7 : 6;
  const propertyVirtualItems = propertyRowVirtualizer.getVirtualItems();
  const propertyPaddingTop = propertyVirtualItems.length > 0 ? propertyVirtualItems[0].start : 0;
  const propertyPaddingBottom = propertyVirtualItems.length > 0 ? propertyRowVirtualizer.getTotalSize() - propertyVirtualItems[propertyVirtualItems.length - 1].end : 0;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.pageWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.pageWrapperNav
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.pageWrapperNavSearch
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.pageWrapperNavSearchInput
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    label: 'Search credential',
    variant: "outlined",
    value: searchCredentialKey,
    onChange: event => {
      var _event$target;
      return setSearchCredentialKey((_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value);
    },
    fullWidth: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pageWrapperNavSearchFilter
  }, /*#__PURE__*/React.createElement(Button, {
    id: "basic-button",
    "aria-controls": !!anchorEl ? 'basic-menu' : undefined,
    "aria-haspopup": "true",
    "aria-expanded": !!anchorEl ? 'true' : undefined,
    onClick: handleClick,
    'custom-attribute': '23-appfolio-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "filter"
  })), /*#__PURE__*/React.createElement(Menu, {
    id: "basic-menu",
    anchorEl: anchorEl,
    open: !!anchorEl,
    onClose: handleClose,
    MenuListProps: {
      'aria-labelledby': 'basic-button'
    }
  }, sortType !== 'asc' && /*#__PURE__*/React.createElement(MenuItem, {
    onClick: () => handleClose('asc')
  }, "Sort by ASC"), sortType !== 'desc' && /*#__PURE__*/React.createElement(MenuItem, {
    onClick: () => handleClose('desc')
  }, "Sort by DESC"), sortType && /*#__PURE__*/React.createElement(MenuItem, {
    onClick: () => handleClose('unsort')
  }, "Unsort")))), /*#__PURE__*/React.createElement("div", {
    className: classes.pageWrapperNavWrapper
  }, data.map(i => {
    var _i$name;
    if (searchCredentialKey === '' || i !== null && i !== void 0 && i.name && i !== null && i !== void 0 && (_i$name = i.name) !== null && _i$name !== void 0 && _i$name.toLocaleLowerCase().includes(searchCredentialKey.trim().toLocaleLowerCase())) return /*#__PURE__*/React.createElement("div", {
      key: i.id,
      className: "".concat(classes.pageWrapperNavItem, " ").concat(activeId === i.id ? 'active' : ''),
      onClick: () => {
        if (activeId === i.id) return;
        handleChangeActiveId(i.id);
      }
    }, i.name);
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.pageWrapperNavAddNew
  }, /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: () => setIsAddNewOpen(false),
    handleOpen: () => setIsAddNewOpen(true),
    isOpen: isAddNewOpen,
    title: 'Add new Credentials',
    noFooter: true,
    trigger: /*#__PURE__*/React.createElement(Button, {
      variant: "priority",
      onClick: () => setIsAddNewOpen(true),
      'custom-attribute': '24-appfolio-page'
    }, "Add new Credentials")
  }, /*#__PURE__*/React.createElement(AddNewForm, {
    callback: fetchAppfolioDateAfterAddNew
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.pageWrapperContent
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.pageWrapperContentWrapper, " ").concat(!data || data.length === 0 ? 'center' : '')
  }, data && data.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.pageWrapperContentTitle
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, (_data$find = data.find(i => i.id === activeId)) === null || _data$find === void 0 ? void 0 : _data$find.name), /*#__PURE__*/React.createElement(EditModalModal, {
    data: data.find(i => i.id === activeId),
    callback: fetchAppfolioDateAfterAddNew
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DeleteModal, {
    data: data.find(i => i.id === activeId),
    callback: fetchAppfolioDate
  }))), data.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.pageWrapperContentDetailsList
  }, /*#__PURE__*/React.createElement("dl", null, /*#__PURE__*/React.createElement("dt", null, "Client Id"), /*#__PURE__*/React.createElement("dd", null, (_data$find2 = data.find(i => i.id === activeId)) === null || _data$find2 === void 0 ? void 0 : _data$find2.clientId)), /*#__PURE__*/React.createElement("dl", null, /*#__PURE__*/React.createElement("dt", null, "Client Secret"), /*#__PURE__*/React.createElement("dd", null, (_data$find3 = data.find(i => i.id === activeId)) === null || _data$find3 === void 0 ? void 0 : _data$find3.clientSecret)), ((_data$find4 = data.find(i => i.id === activeId)) === null || _data$find4 === void 0 ? void 0 : _data$find4.ownerEmail) && /*#__PURE__*/React.createElement("dl", null, /*#__PURE__*/React.createElement("dt", null, "Owner Email"), /*#__PURE__*/React.createElement("dd", null, (_data$find5 = data.find(i => i.id === activeId)) === null || _data$find5 === void 0 ? void 0 : _data$find5.ownerEmail)), ((_data$find6 = data.find(i => i.id === activeId)) === null || _data$find6 === void 0 ? void 0 : _data$find6.companyName) && /*#__PURE__*/React.createElement("dl", null, /*#__PURE__*/React.createElement("dt", null, "Company Name"), /*#__PURE__*/React.createElement("dd", null, (_data$find7 = data.find(i => i.id === activeId)) === null || _data$find7 === void 0 ? void 0 : _data$find7.companyName)), /*#__PURE__*/React.createElement("dl", null, /*#__PURE__*/React.createElement("dt", null, "Users"), /*#__PURE__*/React.createElement("dd", null, /*#__PURE__*/React.createElement(UsersModal, {
    id: activeId
  })))), dataProperties.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.pageWrapperContentProperties, " ").concat(store.credentials.selectedItems.length > 0 ? 'selected' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.pageWrapperContentPropertiesSearch
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    label: 'Search property',
    variant: "outlined",
    value: searchPropertyKey,
    onChange: event => {
      var _event$target2;
      return setSearchPropertyKey((_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.value);
    },
    fullWidth: true
  }))), /*#__PURE__*/React.createElement("div", {
    ref: propertiesScrollRef,
    className: classes.pageWrapperContentPropertiesList
  }, /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table, {
    stickyHeader: true
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Checkbox, {
    checked: store.credentials.selectedItems.length > 0,
    onChange: () => store.credentials.handleGlobalSelectedItems(dataProperties.map(i => i.appfolioPropertyId))
  })), /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, "Name & Appfolio Property Link"), /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, "Address"), isPropertyTableAdmin && /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.inlineTitle
  }, "Batch queue", /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    title: 'Refresh Data',
    placement: "top"
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: classes.inlineTooltip,
    onClick: () => fetchAppfolioBatchQueueDate()
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "reload"
  }))))), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Last Successfull Sync"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Approved"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Errors"))), /*#__PURE__*/React.createElement(TableBody, null, filteredProperties.length === 0 ? /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    colSpan: propertyTableColCount,
    align: "center"
  }, "No properties match your search")) : /*#__PURE__*/React.createElement(React.Fragment, null, propertyPaddingTop > 0 && /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    colSpan: propertyTableColCount,
    style: {
      padding: 0,
      border: 0,
      height: propertyPaddingTop
    }
  })), propertyVirtualItems.map(virtualRow => {
    var _row$errorsDlqIds, _row$errorsDlqIds2, _row$errorsDlqIds3, _row$errorsDlqIds4;
    const row = filteredProperties[virtualRow.index];
    return /*#__PURE__*/React.createElement(TableRow, {
      key: row.appfolioPropertyId,
      "data-index": virtualRow.index,
      ref: propertyRowVirtualizer.measureElement
    }, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Checkbox, {
      checked: store.credentials.selectedItems.includes(row.appfolioPropertyId),
      onChange: () => store.credentials.handleSelectedItems(row.appfolioPropertyId)
    })), /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, row.name, ' ', /*#__PURE__*/React.createElement(ExpandedTooltip, {
      type: "grey",
      title: row.link,
      placement: "top"
    }, /*#__PURE__*/React.createElement(IconButton, {
      onClick: () => window.open(row.link, '_blank')
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "link"
    })))), /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
      type: "grey",
      title: row.address,
      placement: "top"
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.address
    }, row.address))), isPropertyTableAdmin && /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, !row.pendingBatchDeliveryLag ? 'All up to date' : row.pendingBatchDeliveryLag), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, row.lastSuccessfullSyncOn ? row.lastSuccessfullSyncOn : 'N/A'), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, row.isApproved ? 'Yes' : 'No'), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
      type: row.errorsDlqIds && (_row$errorsDlqIds = row.errorsDlqIds) !== null && _row$errorsDlqIds !== void 0 && _row$errorsDlqIds.length ? 'error' : 'success',
      title: row.errorsDlqIds && (_row$errorsDlqIds2 = row.errorsDlqIds) !== null && _row$errorsDlqIds2 !== void 0 && _row$errorsDlqIds2.length ? 'Is Errors' : 'No Errors',
      placement: "top"
    }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
      type: row.errorsDlqIds && (_row$errorsDlqIds3 = row.errorsDlqIds) !== null && _row$errorsDlqIds3 !== void 0 && _row$errorsDlqIds3.length ? 'alert' : 'success',
      state: row.errorsDlqIds && (_row$errorsDlqIds4 = row.errorsDlqIds) !== null && _row$errorsDlqIds4 !== void 0 && _row$errorsDlqIds4.length ? 'error' : 'success'
    })))));
  }), propertyPaddingBottom > 0 && /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    colSpan: propertyTableColCount,
    style: {
      padding: 0,
      border: 0,
      height: propertyPaddingBottom
    }
  }))))))))), (!data || data.length === 0) && /*#__PURE__*/React.createElement(React.Fragment, null, "No credentials"))), store.credentials.selectedItems.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.multiActions
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.multiActionsTitle
  }, "Actions:"), /*#__PURE__*/React.createElement("div", {
    className: classes.multiActionsItems
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    onClick: () => handleMakeApproved(),
    size: "small",
    'custom-attribute': '25-appfolio-page'
  }, "Make items approved"))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.credentials.getCredentialsAsync.inProgress || store.credentials.getCredentialsPropertiesAsync.inProgress || store.credentials.patchCredentialsPropertiesAsync.inProgress
  }));
});